import { render } from "./AcceptedOffers.vue?vue&type=template&id=56784707&scoped=true"
import script from "./AcceptedOffers.vue?vue&type=script&lang=js"
export * from "./AcceptedOffers.vue?vue&type=script&lang=js"

import "./AcceptedOffers.vue?vue&type=style&index=0&id=56784707&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56784707"

export default script